import { render, staticRenderFns } from "./goodsIntro.vue?vue&type=template&id=5455744e&scoped=true"
import script from "./goodsIntro.vue?vue&type=script&lang=js"
export * from "./goodsIntro.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./goodsIntro.vue?vue&type=style&index=1&id=5455744e&prod&lang=stylus"
import style2 from "./goodsIntro.vue?vue&type=style&index=2&id=5455744e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455744e",
  null
  
)

export default component.exports